// src/env.ts
function isImageBitmap(image) {
  return typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap;
}
function isWorker() {
  return typeof importScripts === "function";
}
var getReferrer = isWorker() ? () => self.worker && self.worker.referrer : () => (window.location.protocol === "blob:" ? window.parent : window).location.href;
var userAgent = navigator == null ? void 0 : navigator.userAgent;
var isiOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
var isAndroid = userAgent.indexOf("Android") > -1 || userAgent.indexOf("Adr") > -1;
function isPC() {
  const userAgentInfo = userAgent;
  const Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
  let flag = true;
  for (const v of Agents) {
    if (userAgentInfo.indexOf(v) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}
export {
  getReferrer,
  isAndroid,
  isImageBitmap,
  isPC,
  isWorker,
  isiOS
};
